import axios from "axios";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";

let store: any;
export const injectStore = (_store: any) => {
  store = _store;
}; // Access store directly

export const ax = axios.create();

ax.interceptors.request.use(async (config) => {
  const idToken = localStorage.getItem("token");
  config.baseURL = process.env.REACT_APP_API_URL || "no/api";
  config.headers.common.Authorization = `Bearer ${idToken}`;
  return config;
  /* Same config is also present in redux/common/app.s3.ts, something change please change also there */
});
// Response Interceptor
// for multiple requests

/* NEW */
let isRefreshing = false;
let failedQueue: any = [];
const processQueue = (error: any, token = null) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};
ax.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.isSuccess === true && res.status === 0) {
      // API Successfull
      if (res.successMessage !== "")
        store.dispatch(
          addNotificationAction({
            message: res.successMessage,
            options: { variant: "success" },
          })
        );
    } else if (res.isSuccess === false && res.status === 1) {
      // API Errors
      const requestUrl = String(response?.config?.url || "");
      const rawErrors = Array.isArray(res.errors) ? res.errors : [];

      // Some legacy APIs may create the record but still return a generic
      // "Payment not created." error message for `/create-payment`.
      // Filter out ONLY that exact false-negative message and show any real errors.
      const errors =
        requestUrl.includes("create-payment") && rawErrors.length
          ? rawErrors.filter(
              (x: any) =>
                String(x || "")
                  .trim()
                  .toLowerCase() !== "payment not created."
            )
          : rawErrors;

      errors.length
        ? errors.map((x: any) => {
            store.dispatch(
              addNotificationAction({
                message: x,
                options: { variant: "error" },
              })
            );
          })
        : "";
    } else if (res.isSuccess === false && res.status === 4) {
      // API Validation Errors
      res.validationErrors
        ? res.validationErrors.map((x: any) => {
            store.dispatch(
              addNotificationAction({
                message: x.errorMessage,
                options: { variant: "error" },
              })
            );
          })
        : "";
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.message === "Network Error") {
      store.dispatch(
        addNotificationAction({
          message: "Server Error! Please Contact Network Administrator Extension 051 9052631",

          options: { variant: "error" },
        })
      );

      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      store.dispatch(
        addNotificationAction({
          message: "You are unauthorized for this action",
          options: { variant: "error" },
        })
      );
    }
    if (error.response.status === 403 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return ax(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        const token = localStorage.getItem("token");
        const refreshToken = localStorage.getItem("refreshToken");
        const newForm = { token: `${token}`, refreshToken: `${refreshToken}` };
        ax.post("renew-token", newForm)
          .then(({ data }) => {
            localStorage.setItem("token", data.value.token);
            localStorage.setItem("refreshToken", data.value.refreshToken);
            ax.defaults.headers.common.Authorization = `Bearer ${data.value.token}`;
            originalRequest.headers.Authorization = `Bearer ${data.value.token}`;
            //setting cookie for remember me functionality
            // ax.defaults.headers.common.Cookie = `.AspNetCore.Identity.Application ${data.value.token}`;
            // originalRequest.headers.Cookie = `.AspNetCore.Identity.Application ${data.value.token}`;
            //setting cookie for remember me functionality
            processQueue(null, data.value.token);
            resolve(ax(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  }
);
